// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: /Users/will/dev/uniswap/gringotts/gotts-monorepo/packages/devenv/forge/lib/UniswapX/out/OrderQuoter.sol/OrderQuoter.json

export const ORDER_QUOTER_ABI = [
  {
    type: "receive",
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "getReactor",
    inputs: [
      {
        name: "order",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        name: "reactor",
        type: "address",
        internalType: "contract IReactor",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "quote",
    inputs: [
      {
        name: "order",
        type: "bytes",
        internalType: "bytes",
      },
      {
        name: "sig",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        name: "result",
        type: "tuple",
        internalType: "struct ResolvedOrder",
        components: [
          {
            name: "info",
            type: "tuple",
            internalType: "struct OrderInfo",
            components: [
              {
                name: "reactor",
                type: "address",
                internalType: "contract IReactor",
              },
              {
                name: "swapper",
                type: "address",
                internalType: "address",
              },
              {
                name: "nonce",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "deadline",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "additionalValidationContract",
                type: "address",
                internalType: "contract IValidationCallback",
              },
              {
                name: "additionalValidationData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "input",
            type: "tuple",
            internalType: "struct InputToken",
            components: [
              {
                name: "token",
                type: "address",
                internalType: "contract ERC20",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "maxAmount",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "outputs",
            type: "tuple[]",
            internalType: "struct OutputToken[]",
            components: [
              {
                name: "token",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
            ],
          },
          {
            name: "sig",
            type: "bytes",
            internalType: "bytes",
          },
          {
            name: "hash",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "reactorCallback",
    inputs: [
      {
        name: "resolvedOrders",
        type: "tuple[]",
        internalType: "struct ResolvedOrder[]",
        components: [
          {
            name: "info",
            type: "tuple",
            internalType: "struct OrderInfo",
            components: [
              {
                name: "reactor",
                type: "address",
                internalType: "contract IReactor",
              },
              {
                name: "swapper",
                type: "address",
                internalType: "address",
              },
              {
                name: "nonce",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "deadline",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "additionalValidationContract",
                type: "address",
                internalType: "contract IValidationCallback",
              },
              {
                name: "additionalValidationData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "input",
            type: "tuple",
            internalType: "struct InputToken",
            components: [
              {
                name: "token",
                type: "address",
                internalType: "contract ERC20",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "maxAmount",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "outputs",
            type: "tuple[]",
            internalType: "struct OutputToken[]",
            components: [
              {
                name: "token",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
            ],
          },
          {
            name: "sig",
            type: "bytes",
            internalType: "bytes",
          },
          {
            name: "hash",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "pure",
  },
  {
    type: "error",
    name: "OrdersLengthIncorrect",
    inputs: [],
  },
] as const;

export const ORDER_QUOTER_BYTECODE =
  "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" as const;
